import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import React, { useState } from "react";

import { SubHeader } from "src/flow/SubHeader";
import { useCapabilities } from "src/hooks/useCapabilities";
import { DashboardContent } from "src/layout/DashboardContent";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";
import { AuthProviders } from "src/userManagement/AuthProviders";
import { CreateInviteModal } from "src/userManagement/CreateInviteModal/CreateInviteModal";
import { UserList } from "src/userManagement/UserList";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const UsersPermissionsPage: React.FC = () => {
  const { usersPermissions } = useCapabilities();
  const { orgId } = useParamsDecode<{ orgId: string }>();
  const [inviteUserModal, setInviteUserModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <DashboardContent
      Header={
        <SubHeader title="User permissions">
          <SubHeader.SearchBox
            dataLoc="users-permissions-search-box"
            placeholder="Search users..."
            onChange={setSearchQuery}
          />
          {usersPermissions.canAccess && (
            <SubHeader.Button
              icon={faPlus}
              tooltip="Add user"
              onClick={() => setInviteUserModal(true)}
            />
          )}
        </SubHeader>
      }
    >
      <div className="flex h-full flex-col gap-4">
        <div className="flex min-h-0 flex-1 flex-col">
          <UserList searchQuery={searchQuery} />
        </div>
        {isFeatureFlagEnabled(FEATURE_FLAGS.powertools) && (
          <div className="text-gray-500 font-inter-semibold-13px">
            <AuthProviders orgId={orgId} />
          </div>
        )}
      </div>

      <CreateInviteModal
        open={inviteUserModal}
        organizationId={orgId}
        editableOrgRole
        onClose={() => setInviteUserModal(false)}
      />
    </DashboardContent>
  );
};
